import { render, staticRenderFns } from "./receiveInvite.vue?vue&type=template&id=73ad21c8&scoped=true&lang=pug&"
import script from "./receiveInvite.vue?vue&type=script&lang=js&"
export * from "./receiveInvite.vue?vue&type=script&lang=js&"
import style0 from "./receiveInvite.vue?vue&type=style&index=0&id=73ad21c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ad21c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73ad21c8')) {
      api.createRecord('73ad21c8', component.options)
    } else {
      api.reload('73ad21c8', component.options)
    }
    module.hot.accept("./receiveInvite.vue?vue&type=template&id=73ad21c8&scoped=true&lang=pug&", function () {
      api.rerender('73ad21c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/dialog/receiveInvite.vue"
export default component.exports